import React, { memo } from 'react';
import classNames from 'classnames';

import Button from '../../helpers/Button';

import style from './style.module.css';

const AddTeamComponent = ({ error, roles, users, onSubmit, onCancel }) => (
  <div className={classNames('panel panel-default', style.addTeamHost)}>
    <div className="panel-heading">
      <h5 className={style.panelHeading}>New team</h5>
    </div>
    <div className="panel-body default">
      <form onSubmit={onSubmit}>
        <div className="row">
          <div className="col-md-4 col-lg-3 col-xxl-2">
            <div className="d-flex align-items-center">
              <label htmlFor="leadUserId">Lead</label>
              <select className="form-control input-lg w100p ml10" defaultValue="" id="leadUserId" name="leadUserId">
                <option value="" disabled>
                  Select from directory...
                </option>
                {users?.map(user => {
                  const fullName = `${user.get('firstName')} ${user.get('lastName')}`;

                  return (
                    <option key={user.get('id')} value={user.get('id')}>
                      {fullName}
                    </option>
                  );
                })}
              </select>
            </div>
          </div>
          <div className="col-md-4 col-lg-3 col-xxl-2">
            <div className="d-flex align-items-center">
              <label className="text-nowrap" htmlFor="name">
                Team name
              </label>
              <div className="input-group w100p ml10">
                <input
                  aria-describedby="basic-addon2"
                  className="form-control input-lg"
                  id="name"
                  name="name"
                  placeholder="e.g. Reyes"
                  type="text"
                />
                <span className="input-group-addon" id="basic-addon2">
                  Team
                </span>
              </div>
            </div>
          </div>
          <div className="col-md-4 col-lg-3 col-xxl-2">
            <div className="d-flex align-items-center">
              <label className="text-nowrap" htmlFor="directorDashboardUserTitleId">
                Lead Role
              </label>
              <select
                className="form-control input-lg w100p ml10"
                defaultValue=""
                id="directorDashboardUserTitleId"
                name="directorDashboardUserTitleId"
              >
                <option value="" disabled>
                  Select role...
                </option>
                {roles?.map(role => (
                  <option key={role.get('id')} value={role.get('id')}>
                    {role.get('title')}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>
        {error && (
          <div className="row mt10">
            <div className="col-md-12">
              <p className="text-danger pl0">{error}</p>
            </div>
          </div>
        )}
        <div className="row mt15">
          <div className="col-md-12">
            <Button className="btn-primary" type="submit">
              Create team
            </Button>
            <Button className="btn-default ml10" onClick={onCancel}>
              Cancel
            </Button>
          </div>
        </div>
      </form>
    </div>
  </div>
);

export const AddTeam = memo(AddTeamComponent);
